import { ESCADA_MAX, PASSO_ESCADA_LABEL, type PassoEscada } from "../types";

/** Leitura compacta da escada: 10 barrinhas que enchem até o passo. */
export function EscadaMini({ passo }: { passo: PassoEscada | null }) {
  const v = passo ?? -1;
  const rotulo =
    passo === null ? "sem ofertas ainda" : PASSO_ESCADA_LABEL[passo];
  return (
    <div className="escada-mini" role="img" aria-label={`passo: ${rotulo}`}>
      {Array.from({ length: ESCADA_MAX + 1 }, (_, i) => (
        <i
          key={i}
          className={i <= v ? "on" : ""}
          style={{ height: `${30 + (i / ESCADA_MAX) * 70}%` }}
        />
      ))}
    </div>
  );
}
